export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const VDS_S3_URL = process.env.REACT_APP_VDS_S3_URL;
export const S3_URL = process.env.REACT_APP_S3_URL;
export const VDS_BASE_URL = process.env.REACT_APP_BASE_URL;
export const VERSION = "/api/v1/";
export const VDS_KEY = "vds";
export const BOA_KEY = "boa";
export const FT_KEY = "ft";
export const SQW_KEY = "sqw";
export const ADVISOR_KEY = "adv";
export const RESULT_ANALYSIS_KEY = "resultanalysis";
export const COMMON = "common";
let tabs = {
  rs: "real-estates",
  in: "Insurance/",
  rm: "materials",
  s: "securities",
  sh: "share-holdings",
  loan: "loans",
  cosh: "corporate-share-holdings",
  ss: "other-holdings",
  u: "user/",
};

export const uUrls = {
  LOGIN_USER: "authentication",
  REGISTER_USER: "registration",
  CHANGE_PASSWORD: "change-password",
  CREATE_PASSWORD: "create-password",
  FORGOT_PASSWORD: "users/forgot-password",
  RESET_PASSWORD: "reset-password",
  TOKEN_VALIDATION: "token-validation",
  PHONE_NUMBER_VERIFICATION: "phoneNumber-verification",
  USER_PROFILE: "profile",
  LANGUAGE_PREFERENCE: "language-perference",
  RESET_TOKEN_VARIFICATION: "reset-token-verification",
  BRANCH_LOGO: "media",
};

export const vdsUrls = {
  LOGIN_USER: "users/authentication",
  USER_PROFILE: "user/profile",
  USER_LANGUAGE_PREFERENCE: "user/language-preference",
  LOGOUT_USER: "users/logout",
  USER_DETAIL: "users",
  USERS: "users",
  GENERATIONAL_CONSULTANTS: "consultant",
  USER_NUMBER_VERIFICATION: "users/confirm-phone-number",
  OTP_VERIFICATION: "users/verify-otp",
  RESEND_OTP: function () {
    return `${this.USERS}/resend-otp`;
  },
};
export const commonUrls = {
  FILE_STTREAM: "media/stream",
};
export const rsUrls = {
  GET_RS_CATEGORY_LIST: "real-estate-categories",
  SAVE_RS_USER: tabs.rs + "SaveUserRealEstate",
  GET_ALL_RS_USERS: tabs.rs + "",
  DELETE_RS_USER: tabs.rs + "DeleteUserRealEstate/",
  UPDATE_RS_USER: tabs.rs + "",
};

export const InUrls = {
  GET_INSURANCE_TYPES: "insurance-categories",
  USER_INSURANCES: "insurances",
  INSURANCE_DOCUMENT: "insurance-document",
  DOWNLOAD_INSURANCE_DOCUMENT: "download-insurance-document",
};
export const rmUrls = {
  GET_rm_List: "material-categories",
  SAVE_rm: tabs.rm + "",
  GET_GOLD_rm_List: tabs.rm + "",
  UPDATE_rm_List: tabs.rm + "",
};

export const bbUrls = {
  BA_USERS: "bank-accounts",
};

export const donationsUrls = {
  DONATIONS_LIST: "donations",
  SAVE_DONATIONS: "donations",
};
export const sUrls = {
  SAVE_USERS_S: tabs.s + "",
  DELETE_S: tabs.s + "DeleteUserSecurityById/",
  GET_ALL_USERS_S: tabs.s + "",
  UPDATE_USER_S: tabs.s + "",
};
export const shUrls = {
  SAVE_USERS_SH: tabs.sh + "",
  DELETE_SH: tabs.sh + "",
  GET_ALL_USERS_SH: tabs.sh + "",
  GET_LOANS: tabs.loan + "",
  SAVE_LOANS: tabs.loan + "",
  UPDATE_USER_SH: tabs.sh + "",
};
export const loansUrls = {
  GET_LOANS: tabs.loan + "",
  SAVE_LOANS: tabs.loan + "",
};
export const coshUrls = {
  SAVE_USERS_COSH: tabs.cosh + "",
  DELETE_COSH: tabs.cosh + "",
  GET_ALL_USERS_COSH: tabs.cosh + "",
  UPDATE_USER_COSH: tabs.cosh + "",
};
export const ssUrls = {
  SAVE_USERS_SS: tabs.ss + "",
  DELETE_SS: tabs.ss + "",
  GET_ALL_USERS_SS: tabs.ss + "",
  UPDATE_USER_SS: tabs.ss + "",
  GET_TYPES_SS: "other-holding-categories",
};

export const ftUrls = {
  GET_RELATIONSHIP_LIST: "relationships",
  ADD_MEMBER: "family-tree",
  GET_FAMILY_TREE: "family-tree",
  ADD_PROFILE_PICTURE: "familytree-image",
  GET_MARRIAGE_TYPES: "marriage-types",
  SUB_CHILDS: "childs-grandChilds",
};
export const soiUrls = {
  GET_SHARE_OF_INHERITANCE_LIST: "inheritance-shares",
  UPDATE_SHARE_OF_INHERITANCE_LIST: "inheritance-shares",
  GET_TAX: "tax",
};

export const relationshipsUrls = {
  ALL_RELATIONSHIP: "relationships",
};

export const cUrls = {
  GET_TAB_VIEW: "about-views",
  UPDATE_TAB_VIEW: "about-views",
  IMPORT_TAB_DOCUMENT: "boa-user-media",
  DOWNLOAD_TAB_DOCUMENT: "download-boa-media-stream",
  GET_FT_ABOUT_STATUS_VIEW: "about-views",
  UPDATE_FT_ABOUT_STATUS_VIEW: "about-views",
};
export const documentsUrls = {
  HEALTHCARE_PROXY: "health-proxy",
  HEALTHCARE_PROXY_ALL_QUESTIONS: "health-proxy-questions",
  HEALTHCARE_PROXY_QUESTIONS_BY_CATEGORY:
    "health-proxy-questions-by-category-types?categoryTypes=",
  GUARDIAN_ORDINANCE: "guardian-ordinance",
};
export const yourWishesUrls = {
  GET_STATUS_QUO: "status-quo",
  USER_STATUS_QUO: "user-status-quo",
  USER_STATUS_QUO_WITH_MEDIA: "user-status-quo-with-media",
  USER_STATUS_QUO_MEDIA: "status-quo-media",
  USER_WISH: "user-wish",
};

export const checkList = {
  GET_CHECK_LIST: "document-checklists",
};

export const careDirectiveUrls = {
  CARE_DIRECTIVE_DATA: "care-directive",
};
export const appointmentUrls = {
  APPOINTMENT: "appointment",
  APPOINTMENTS: "appointments",
};
export const organDonationUrls = {
  ORGAN_DONATION_DATA: "organ-donation",
};
export const casesUrls = {
  CASES_LIST: "cases",
  CASE: "case",
};
export const pdfDownloadUrls = {
  HEALTH_PROXY: "health-proxy-pdf",
  GUARDIAN_ORDINANCE: "guardian-ordinance-pdf",
  CARE_DIRECTIVE: "care-directive-pdf",
  CUSTODY_ORDER: "custody-order-pdf",
  ORGAN_DOANTION: "organ-donation-pdf",
};

export const reportUrls = {
  REPORT: "reports",
  GENERATE_REPORT: "generate-report",
};

export const autditTrails = {
  AUDIT_TRAIL: "audit-trails",
  INACTIVE_AUDIT_TRAILS: "inactive-audit-trails",
};
export const sectionStatus = {
  SECTION_STATUS: "section-statuses",
};

export const translationUrl = {
  TRANSLATION: "translations",
};

export const faqTranslation = {
  FAQ: "faqs",
};
export const CANCEL_SUBSCRIPTION = 'off-board';
